module.exports = __webpack_public_path__ + "img/ico_group_minus.a3f66ea7.svg";